import React, { createContext, useState, ReactNode } from 'react'

// Define the type for the context value
interface SidebarContextType {
  view: string
  setView: React.Dispatch<React.SetStateAction<string>>
  viewBool: boolean
  setViewBool: React.Dispatch<React.SetStateAction<boolean>>
}

// Create the context with default undefined values

const defaultValue: SidebarContextType = {
  view: '',
  setView: () => {},
  viewBool: false,
  setViewBool: () => {},
}
export const SidebarContext = createContext<SidebarContextType>(defaultValue)

// Define the provider component props
interface SidebarProviderProps {
  children: ReactNode
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({
  children,
}) => {
  const [view, setView] = useState<string>('centeral-records') // Initial value set to "yes"
  const [viewBool, setViewBool] = useState<boolean>(false) // Initial value set to "yes"

  return (
    <SidebarContext.Provider value={{ view, setView, viewBool, setViewBool }}>
      {children}
    </SidebarContext.Provider>
  )
}
